<template>
    <div class="attractions-tab-cards">
        <nav class="attractions-tab-cards-nav">
            <button
                v-for="tab in tabs"
                :key="tab.date"
                :class="{ active: activeTabDate === tab.date }"
                @click="setActiveTab(tab.date)"
            >
                <i class="fa fa-calendar"></i>
                <div>
                    <small>{{ tab.day }}</small>
                    <span>{{ tab.dayNumber }} {{ tab.month }}</span>
                </div>
            </button>
        </nav>

        <div
            class="attractions-tab-cards-content"
            :class="`items-${itemsCount}`"
        >
            <div
                class="attractions-tab-cards-item"
                v-for="(item, index) in getItemByActiveTab()"
                :key="`${item.date}-${index}`"
            >
                <figure
                    class="content-image"
                    :class="randomBackgroundClass(index)"
                >
                    <img :src="item.image" :alt="item.title" />
                </figure>
                <div class="content-text">
                    <span>
                        {{ getDay(item.date) }} | {{ getDayNumber(item.date) }}
                        {{ getMonth(item.date) }}
                    </span>
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },
        lang: {
            type: String,
            required: false,
            default: () => "en-US"
        }
    },
    data() {
        return {
            activeTabDate: null,
            backgroundRandomOrder: this.generateRandomBackgroundOrder()
        };
    },
    mounted() {
        if (this.sortedItems && this.sortedItems.length > 0) {
            this.activeTabDate = this.sortedItems[0].date;
        }
    },
    computed: {
        sortedItems() {
            return [...this.items].sort((a, b) => {
                const da = this.parseLocalDate(a.date);
                const db = this.parseLocalDate(b.date);
                return da - db;
            });
        },
        tabs() {
            return this.sortedItems
                .filter(
                    (item, index, self) =>
                        index === self.findIndex(t => t.date === item.date)
                )
                .map(item => ({
                    date: item.date,
                    day: this.getDay(item.date),
                    dayNumber: this.getDayNumber(item.date),
                    month: this.getMonth(item.date)
                }));
        },
        itemsCount() {
            return this.getItemByActiveTab().length;
        }
    },
    methods: {
        parseLocalDate(isoDate) {
            const [y, m, d] = String(isoDate)
                .split("T")[0]
                .split("-")
                .map(Number);

            return new Date(y, (m || 1) - 1, d || 1);
        },
        getDay(id) {
            const date = this.parseLocalDate(id);
            return date.toLocaleDateString(this.lang, {
                weekday: "long"
            });
        },
        getMonth(id) {
            const date = this.parseLocalDate(id);
            return date.toLocaleDateString(this.lang, {
                month: "short"
            });
        },
        getDayNumber(id) {
            const date = this.parseLocalDate(id);
            return date.toLocaleDateString(this.lang, {
                day: "numeric"
            });
        },
        setActiveTab(id) {
            this.activeTabDate = id;
            this.backgroundRandomOrder = this.generateRandomBackgroundOrder();
        },
        getItemByActiveTab() {
            return this.sortedItems.filter(
                item => item.date === this.activeTabDate
            );
        },
        generateRandomBackgroundOrder() {
            return [1, 2, 3, 4].sort(() => Math.random() - 0.5);
        },
        randomBackgroundClass(index) {
            return `bg-${this.backgroundRandomOrder[index]}`;
        }
    }
};
</script>
